import { Position } from "./positions.model";
import { Role } from "./role.model";

export enum LeagueTypeCode {
  League = "league",
  CupPlayoff = "cup_playoff",
  LeaguePlayoff = "league_playoff",
  LeagueTwice = "league_twice",
  RegistrationLeague = "registration_league"
}

export interface LeagueType {
  code: LeagueTypeCode;
  name: string;
}

export interface LeagueBase {
  id: number;
  name: string;
}

export interface League extends LeagueBase {
  sport_event_id: number;
  description: string;
  league_type: LeagueType;
  league_order: number;
  day_of_league: string;
}

export interface LeagueTableItem {
  team_id: number;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  for: number;
  against: number;
  points: number;
  goals_diff: number;
  pos: number;
  team: LeagueTeam;
}

export interface LeagueTeam {
  id: number;
  name: string;
  display_name: string;
  uniform_color: string;
  uniform_color_hex: string;
  logo_path: string;
  captain_name: string;
  pivot: {
    league_id: number;
    team_id: number;
    is_entry_fee_ok?: boolean;
    status: number;
    statement: boolean;
    registered_name: string;
    created_at: string;
    taken_points: number;
  };
  goals: number;
  penalty: number | null;
  half_time_goals: number | null;
  best_player: number | null;
  teammembers: LeagueTeamMember[];
  facebook_profile: string;
}

export interface LeagueTeamMember {
  id: number;
  user_id: number;
  name: string;
  role_id: number;
  role: Role;
  position_id: number;
  position: Position;
  squad_number: number;
  is_confirmed: true;
  last_sent_invitation: "2020-03-03T06:46:38.615Z";
  goals: number;
}

export type LeagueTable = LeagueTableItem[];

export interface Scorer {
  id: number;
  name: string;
  goals: number;
  team: LeagueTeam;
}

export interface LeagueTeamMemberRegistration {
  team_id: number;
  team_member_ids: SelectedTeamMember[];
}

export interface LeagueRegistration extends LeagueTeamMemberRegistration {
  statement: boolean;
  recommended_by?: string;
}

export interface SelectedTeamMember {
  user_id: number;
  squad_number: number;
}

export interface TeamMemberForSelection {
  selected: boolean;
  userId: number;
  squadNumber: number;
  name: string;
}
